import gsap from 'gsap';
class Blob {
    
    constructor(resistance, safetyRingAroundBlob, onDeath) {
        this.x = width / 2;    
        this.y = height / 2;

        this.status = "alive";
        
        this.diameter = 0;
        this.pulsePhase = -1;
        this.pulse = 0;
        this.pulse = {
            phase: -1,
            current: 0,
            increment: 15,
            max: 100
        };
        this.minSize = resistance !== 1 ? safetyRingAroundBlob * 2 : safetyRingAroundBlob;
        this.resistance = resistance;
        this.bounds = [];
        this.wasHit = false;
        this.canGrow = true;
        this.growSpeed = {
            initial: .1,
            max: 4,
            step: 0,
            timesToMax: 120,
            delayToStart: 90,
            current: .5,
        }
        this.health = {
            current: 1500,
            max: resistance === 1 ? 2000 : -1,
            opacity: 0
        }

        if(resistance === 1) {
            this.growSpeed.max = .5;
            if(window.innerWidth < 767) {
                this.health.current = 250;
                this.health.max = 250
            }
        }

        this.explodyBits = [];
        this.onDeath = () => {
            onDeath();
            this.explode();
            this.status = "dead";
        }
    }

    explode() {
        for(let i = 0; i < 20; i++) {
            const r = PI * random(.1, 2);
            const d = random(.1, this.diameter*2)
            const tX = width/2 + sin(r)*d;
            const tY = height/2 + cos(r)*d;

            const size = random(this.diameter/10, this.diameter/1.5);
            const x = width/2;
            const y = height/2;
            const bit = {
                x,
                y,
                size
            }
            gsap.to(bit, {x: tX, y:tY, duration: random(.5, 1)});
            gsap.to(bit, {size: 0, duration: 2, delay:.5});
            this.explodyBits.push(bit);
        }
    }

    updateGrowSpeed = () => {
        this.growSpeed.step++;
        if(this.growSpeed.step > this.growSpeed.delayToStart) {
            const diff = this.growSpeed.max - this.growSpeed.initial
            this.growSpeed.current = this.growSpeed.initial + diff*(this.growSpeed.step / this.growSpeed.timesToMax)
            if(this.health.opacity < 255) {
                this.health.opacity+=5;
            }
        }
    }

    computePulse = () => {
        if(this.pulse.current > this.pulse.max) {
            this.pulse.phase = -1;
        }
        else if(this.pulse.current < -this.pulse.max) {
            this.pulse.phase = 1;
        }
        this.pulse.current += this.pulse.increment * this.pulse.phase;
    }

    getHit() {
        const minDiameter = this.minSize;
        if(this.diameter > minDiameter && (!this.wasHit || this.resistance===1)) {
            const extra = this.resistance < 1 ? .25 : 0;
            const r = random();
            
            if(r > 1 - this.resistance + extra) {
                this.diameter -= this.growSpeed.current;
                this.canGrow = false;
            }
        }
        if(this.health.max !== -1) {
            this.health.current -= 1;
            if(this.health.current <=0) {
                this.onDeath();
            }
        }
        this.wasHit = true;
    }

    draw = () => {

        if(this.status === 'dead') {
            if(this.explodyBits.length > 0) {
                this.explodyBits.forEach(b => {
                    fill(10, 10, 10, 200);
                    circle(b.x, b.y, b.size);
                })
            }
            return;
        }
        if(this.wasHit) {
            fill(10, 10, 10, 200);
            stroke(0, 0, 0);
            this.wasHit = false;
        }
        else {
            fill(10, 10, 10, 250);
            stroke(0, 0, 0);
        }
        

        this.updateGrowSpeed();
        
        
        
        if(this.canGrow) {
            this.diameter+=this.growSpeed.current;
        }
        else {
            this.canGrow = true;
        }
        
        
        this.bounds = [];
        beginShape();
        const len = 48;
        const sides =  len/3;
        const magnitude = this.diameter*.05;
        const offset = 20;
        for(let i = 0; i < len; i++) {
            let x = this.x + sin((PI*2)/len * i) * this.diameter/2;
            let y = this.y + cos((PI*2)/len * i) * this.diameter/2;

            const pulse = this.pulse.current / this.pulse.max;
            x-= sin(PI*sides * i/len) * (magnitude*pulse);
            y-= cos(PI*sides * i/len) * (magnitude*pulse);
            vertex(x, y);
            this.bounds.push([x, y]);
        }
        endShape();

        if(this.health.max !== -1) {
            const w = 40;
            const h = 4;
            const cw = w * this.health.current/this.health.max;
            noStroke();
            fill(0, 0, 0, this.health.opacity);
            rect(this.x - w/2, this.y - h/2, w, h);
            fill(211, 70, 87, this.health.opacity);
            rect(this.x - w/2, this.y - h/2, cw, h);
        }

        this.computePulse();
    }
}

export default Blob;